/* eslint react/prop-types: 0 */

import React from "react";
import { Label } from "reactstrap";
import { SelectPerusahaan, SelectFilterYear } from "../../component/Utils";
import { isBiro } from "../../utils/helper";

export const HeaderCompReport = () => {
  return (
    <div className="card border-0 rounded-0">
      <div className="container py-4">
        <div className="row px-4">
          <div className="col-md-4 d-flex align-items-center ">
            <h3 className="mr-auto my-auto">Laporan Keuangan</h3>
          </div>
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-9 d-flex justify-content-end align-items-center">
                {isBiro() && (
                  <>
                    <Label className="mr-3">Perusahaan</Label>
                    <SelectPerusahaan default={true} />
                  </>
                )}
              </div>
              <div className="col-md-3 d-flex justify-content-end align-items-center mt-md-0 mt-3">
                <Label className="mr-3">Tahun</Label>
                <SelectFilterYear />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
